import React from "react";
import {Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, Chip, Container, FormControlLabel, FormGroup, Typography} from "@mui/material";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

export default function AddService(props) {
  const [state, setState] = React.useState({
    ...props.state
  });
  const [expanded, setExpanded] = React.useState();
  const closeDrawerAddService = () => {
    props.setValue("st004310List", state.st004310List);
    props.setValue("st004310ViewList", state.st004310ViewList);
    document.getElementById("add_service_btn").click();
  };
  const changeChips = (service, checked) => {
    if (checked) {
      setState({...state, st004310List: [...state.st004310List, service], st004310ViewList: [...state.st004310ViewList, service]});
    } else {
      setState({...state, st004310List: state.st004310List.filter((svs) => svs[0] !== parseInt(service[0])), st004310ViewList: state.st004310ViewList.filter((svs) => svs[0] !== parseInt(service[0]))});
    }
  };
  const toggleExpanded = (listNm) => {
    setExpanded( expanded !== listNm || !Boolean(expanded) ? listNm : false);
  };

  return (
    <Container
      maxWidth = "sm"
      sx = {{p: 2, pt: 0, flexGrow: 1}}
    >
      <Box
        className = "bgcolor-white"
        position = "sticky"
        sx = {{top: 0, zIndex: 1, pt: 1, pb: 1}}
      >
        <Box
            sx = {{mb: 2, textAlign: "right"}}
        >
          <Button
            className = "btn-submit"
            id = "submit_koumoku_btn"
            onClick = {closeDrawerAddService}
            sx = {{mt: 2, p: 0.5, width: 120, borderRadius: 12}}
          >
            <Typography
              className = "btn-txt-lg"
            >
              完了
            </Typography>
          </Button>
        </Box>
        <Box
          className = "content select-container"
          sx = {{minHeight: 32, mb: 2, p: 1}}
        >
            {state.st004310ViewList.map((st004310v) => (
              !Boolean(state.st004300List.find(st004300 => st004300[0] === st004310v[0])) &&
              <Chip
                key = {st004310v[0]}
                label = {st004310v[1]}
                onDelete = {() => changeChips(st004310v, false)}
                sx = {{fontSize: "1rem"}}
              />
            ))}
        </Box>
      </Box>
      {state.serviceList.map((list) => (
        <Accordion
          expanded = {expanded === list[0]}
          key = {list[0]}
          sx = {{m: "2px!important", boxShadow: "none"}}
        >
          <AccordionSummary
            className = "btn-select"
            onClick = {() => toggleExpanded(list[0])}
            sx = {{height: 45, minHeight: "0!important"}}
          >
            <Typography>
              {list[0]}
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx = {{p: 0, pt: 1}}
          >
            <Container
              maxWidth = "sm"
              sx = {{minHeight: list[1].filter(service => !Boolean(state.st004300List.find(st004300 => st004300[0] === service[0]))).length * 46, flexGrow: 1}}
            >
              {expanded === list[0] &&
              list[1].filter(service => !Boolean(state.st004300List.find(st004300 => st004300[0] === service[0]))).map((service) => (
                <FormGroup
                  key = {service[0]}
                >
                  <FormControlLabel
                    control = {
                      <Checkbox
                        icon = {<RadioButtonUncheckedIcon />}
                        checkedIcon = {
                          <TaskAltIcon
                            color = "success"
                          />
                        }
                        color = "default"
                      />
                    }
                    checked = {Boolean(state.st004310ViewList.find(st004310v => st004310v[0] === service[0]))}
                    label = {service[1]}
                    onChange = {(e) => changeChips(service, e.target.checked)}
                  />
                </FormGroup>
              ))}
            </Container>
          </AccordionDetails>
        </Accordion>
      ))}
    </Container>
  );
};
